<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;"><span class="bold">Contents</span></h2>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber1" style="text-indent: 0%;"><a href="#/9781466804876_pt01#pt01">Part I</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left:5%;"><a href="#/9781466804876_ch01#ch01">Chapter 1: Ignition</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left:5%;"><a href="#/9781466804876_ch02#ch02">Chapter 2: Nant Day</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left:5%;"><a href="#/9781466804876_ch03#ch03">Chapter 3: Orphid Night</a></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber0" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch04#ch04" title="Link target outside of Sample">Chapter 4: Chu’s Knot</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber1" style="text-indent: 0%;"><span href="#/9781466804876_pt02#pt02" title="Link target outside of Sample">Part II</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch05#ch05" title="Link target outside of Sample">Chapter 5: The Big Pig Posse</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch06#ch06" title="Link target outside of Sample">Chapter 6: Nektar’s Beetles</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber0" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch07#ch07" title="Link target outside of Sample">Chapter 7: The Grill in the Wall</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber1" style="text-indent: 0%;"><span href="#/9781466804876_pt03#pt03" title="Link target outside of Sample">Part III</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch08#ch08" title="Link target outside of Sample">Chapter 8: Thuy’s Metanovel</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch09#ch09" title="Link target outside of Sample">Chapter 9: The Attack Shoons</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber0" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch10#ch10" title="Link target outside of Sample">Chapter 10: The Ark of the Nants</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber1" style="text-indent: 0%;"><span href="#/9781466804876_pt04#pt04" title="Link target outside of Sample">Part IV</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch11#ch11" title="Link target outside of Sample">Chapter 11: The Hibrane</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryNumber0" style="text-indent: 0%; margin-left:5%;"><span href="#/9781466804876_ch12#ch12" title="Link target outside of Sample">Chapter 12: Lazy Eight</span></p></div>
<div class="contentsEntry" style="text-indent: 0%;">
<p class="contentsEntryName" style="text-indent: 0%;"><span href="#/9781466804876_ack01#ack01" title="Link target outside of Sample">Acknowledgments</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781466804876_con01.vue?2f088adc